import { render, staticRenderFns } from "./ChineseMedicine.vue?vue&type=template&id=c266e33c&scoped=true&"
import script from "./ChineseMedicine.vue?vue&type=script&lang=js&"
export * from "./ChineseMedicine.vue?vue&type=script&lang=js&"
import style0 from "./ChineseMedicine.vue?vue&type=style&index=0&id=c266e33c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c266e33c",
  null
  
)

export default component.exports